import { ApiResponse, create } from "apisauce";
import { env } from "../utils/env/config";
import { getAuthToken } from "../utils/storage/storage";
import { IMode, IReponse } from "./interface";

export const MODE_API: IMode | any = {
  DEVELOPMENT: env.url_dev,
  UAT: env.url_uat,
  PRODUCTION: env.url_prd,
};

export const CONNECT_API = MODE_API[`${env.node}`.toUpperCase()];

const api = create({
  baseURL: CONNECT_API,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 300000, // 10 seconds
});

const apiupload = create({
  baseURL: CONNECT_API,
  withCredentials: true,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

const onReponse = (response: ApiResponse<any>, resolve: any, reject: any) => {
  if (response.ok) {
    resolve(response.data);
  } else {
    response.data
      ? reject(response.data)
      : reject({ success: false, message: response.problem });
  }
};

export const POST = (
  path: string,
  obj: any,
  token: string = getAuthToken()
): Promise<IReponse> =>
  new Promise((resolve, reject) => {
    api
      .post(path, obj, {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      })
      .then((response) => onReponse(response, resolve, reject))
      .catch((err) => reject(err));
  });

/**
 * ฟังก์ชั่นสำหรับ ดึงข้อมูล
 * @param {string} path
 *
 */
export const GET = (
  path: string,
  token: string = getAuthToken()
): Promise<IReponse> =>
  new Promise((resolve, reject) => {
    api
      .get(
        path,
        {},
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      )
      .then((response) => onReponse(response, resolve, reject))
      .catch((err) => reject(err));
  });

export const DOWNLOAD = (path: string): Promise<IReponse> =>
  new Promise((resolve, reject) => {
    api
      .get(
        path,
        {},
        {
          responseType: "blob",
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
        }
      )
      .then((response) => onReponse(response, resolve, reject))
      .catch((error) => reject(error));
  });

export const UPLOAD = (
  path: string,
  formdata: any,
  token: string = getAuthToken()
) =>
  new Promise((resolve, reject) => {
    apiupload
      .post(path, formdata, {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      })
      .then((response) => onReponse(response, resolve, reject))
      .catch((err) => reject(err));
  });

export const PUT = (
  path: string,
  obj: any,
  token: string = getAuthToken()
): Promise<IReponse> =>
  new Promise((resolve, reject) => {
    api
      .put(path, obj, {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      })
      .then((response) => onReponse(response, resolve, reject))
      .catch((err) => reject(err));
  });

export const DELETE = (
  path: string,
  obj?: any,
  token: string = getAuthToken()
): Promise<IReponse> =>
  new Promise((resolve, reject) => {
    api
      .delete(path, obj, {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      })
      .then((response) => onReponse(response, resolve, reject))
      .catch((err) => reject(err));
  });

/* ################################################## URL ################################################## */
export const LOGIN_GOOGLE = `/auth/login-google`;
export const GET_PROFILE = `/auth/profile`;
export const GET_IMPORT_DEVICE_STATUS_OPTION = `/form/import-device-status-option`;
export const GET_DEVICES = `/device/get-devices`;
export const DOWLOAD_EXMAPLE_IMPORTED_DEVICE = `/file/example-imported-device`;
export const UPLOAD_EXCEL = `/file/upload-excel`;
export const CREATE_DEVICES = `/device/create`;
export const GET_DEVICES_LOT = `/device/get-devices-lot`;
export const QC_CONFIRM = `/device/qc-confirm`;
export const GET_DEVICES_iNVOICE = `/device/get-devices-invoice`;
export const UPDATE_DEVICE = (deviceId: string) =>
  `/device/update-device/${deviceId}`;
export const GET_MAINTAIN_DEVICE_STATUS_OPTION = `/form/maintain-device-status-option`;
export const GET_DELIVERY_OPTION = `/form/delivery-option`;
export const GET_MAINTENANCES = `/maintenance/get-maintenances`;
export const GET_MAINTENANCES_IMAGES = `/maintenance/get-images`;
export const GET_MACHINE_IMAGES = (maintainId: string) =>
  `/maintenance/${maintainId}/machine-images`;
export const GET_ITEM_CODE_MACHINE = (itemCode: string) =>
  `/maintenance/get-itemCode-machine?itemCode=${itemCode}`;
export const GET_MAINTENANCES_LINES = `/maintenance/get-lines`;
export const GET_MAINTENANCES_DETAIL = (maintainId: string) =>
  `/maintenance/get-flow-detail?maintainId=${maintainId}`;

export const GET_CHANGE_DEVICE = `/maintenance/change/get`;
export const GET_CHANGE_DEVICE_QURRY = (qurryStringData: string) =>
  `/maintenance/change/get?${qurryStringData}`;
export const GET_CHANGE_DEVICE_OPTION = `/form/status-option?type=CHANGE-DEVICE`;
export const GET_ADDRESS_CUSTOMER = (customerCode: string) =>
  `/customer/get-address?customerCode=${customerCode}`;
export const CHANGE_DELETE = (mainId: string) =>
  `/maintenance/change/delete/${mainId}`;
export const GET_RESERVATION_LIST = `/reservation/list-reservation`;
export const GET_RESERVATION_LIST_QURRY = (qurryStringData: string) =>
  `/reservation/list-reservation?${qurryStringData}`;
export const UPDATE_CHANGE_ADDRESS = `/maintenance/change/update`;
export const UPDATE_POST_ITR = `/maintenance/change/update-post-itr`;
export const RESERVATION_CONFIRM = `/reservation/confirm`;
export const RESERVATION_DELETE = (reserveId: string) =>
  `/reservation/delete-reservation/${reserveId}`;
export const PRODUCT_CONFIRM = `/maintenance/product-confirm`;
export const MECHANIC_COMFIRM = `/maintenance/mechanic-confirm`;
export const MECHANIC_CLOSE = `/maintenance/mechanic-close`;
export const PRODUCT_CLOSE = `/maintenance/product-close`;
export const GET_SERVICE_OPTION = `/form/service-option`;
export const GET_SPARE_PART_OPTION = `form/spare-part-option`;
export const GET_RESERVE_OPTION = `/form/status-option?type=RESERVE`;
export const POST_EXPORT_SPARE = `/maintenance/export-excel-spare`;

export const UPDATE_MAINTENANCE = `/maintenance/update-maintenance`;
export const GET_COUNT_RESERVATION = `/reservation/count-reservation`;

export const MAINTENANCE_DELETE = (maintainId: string, remark = "") =>
  `/maintenance/delete-maintenance/${maintainId}?remark=${encodeURIComponent(
    remark
  )}`;

export const GET_SPARE_DEVICE = `/maintenance/spare/get`;

export const GET_SPARE_DEVICE_QUERY = (queryString: string) =>
  `/maintenance/spare/get?${queryString}`;

export const GET_CHANGE_SPARE_OPTION = `/form/status-option?type=SPARE-DEVICE`;

export const SPARE_DELETE = (spareId: string) =>
  `/maintenance/spare/delete/${spareId}`;

export const CONFIRM_SPARE_DEVICE = `/maintenance/spare/confirm`;
export const UPLOAD_MODEL_EXCEL = `/file/upload-model-excel`;
export const CREATE_MODEL = `/model/create`;
export const DOWNLOAD_MODELS_MASTER = `/file/download-models-master`;
export const DOWNLOAD_MODELS_DATA = `/file/download-models-data`;
export const DOWNLOAD_EXAMPLE_IMPORTED_MODEL = `/file/example-imported-model`;
